<template>
<div id="policy" :class="{'pa-2 ma-2': $vuetify.breakpoint.mdAndUp}" style="padding-bottom: 70px !important">
    <im-header :loading="loading">
        <template v-slot:title>
            <v-icon size="32" class="" @click="back()">keyboard_arrow_left</v-icon>
            <span v-if="$route.params.id">{{name}}</span>
            <span slot="title" v-else>{{ $t('cancellation_policy.title_create') }}</span>
        </template>
        <template v-slot:right-content>
            <span></span>
        </template>
    </im-header>

    <v-container fluid :class="{ 'px-2': $vuetify.breakpoint.smAndDown, 'pt-3 im-card-items': true}">
        <v-card flat :class="{ 'pa-3': $vuetify.breakpoint.smAndUp, 'im-card': true }">
            <v-form v-model="valid" ref="form">
                <v-card-text>
                    <v-row>
                        <v-col md="6" sm="9" cols="12" class="px-2">
                            <v-text-field v-model="policy.name" :label="$t('cancellation_policy.name')" required :rules="rules.name" />
                        </v-col>
                    </v-row>
                    <div class="pa-2">
                        <v-radio-group v-model="policy.refundable" row>
                            <v-radio :label="$t('cancellation_policy.refundable')" :value="true"></v-radio>
                            <v-radio :label="$t('cancellation_policy.non_refundable')" :value="false"></v-radio>
                        </v-radio-group>
                        <v-radio-group v-if="policy.refundable" v-model="full_refundable">
                            <v-radio :label="$t('cancellation_policy.full_refundable')" :value="true"></v-radio>
                            <v-radio :label="$t('cancellation_policy.partial_refundable')" :value="false" @change="(policy.rules.length==0)?addFirstRule():''"></v-radio>
                        </v-radio-group>
                    </div>
                    <div v-if="policy.refundable&&!full_refundable">
                        <div class="important px-2">{{ $t('cancellation_policy.title_penalty_rules') }}</div>
                        <div class="pa-2">
                            <v-textarea v-model="description" color="primary" :label="$t('cancellation_policy.description')" rows="1" auto-grow readonly />
                        </div>
                        <div class="pa-2 regular" v-if="!policy.rules.length > 0">
                            {{ policy.text.ro }}
                        </div>
                        <v-row v-for="(item, index) in policy.rules" :key="index" align="center">
                            <v-col md="6" cols="12" class="py-0">
                                <v-row align="center">
                                    <v-col cols="6" class="py-0" order-1 v-if="$vuetify.breakpoint.smAndUp">
                                        <div v-if="item.interval_type == 'days-until-check-in'">
                                            {{ $t('cancellation_policy.rule.text.days_part_one') }}
                                        </div>
                                        <div v-if="item.interval_type == 'before-hour-on-check-in-day'">
                                            {{ $t('cancellation_policy.rule.text.hour_part_one') }}
                                        </div>
                                    </v-col>
                                    <v-col sm="3" cols="6" :order-2="item.interval_type == 'days-until-check-in'" :order-3="item.interval_type == 'before-hour-on-check-in-day'" class="py-0">
                                        <v-text-field :label="$t('cancellation_policy.rule.interval_type')" v-model="item.interval_value" required :rules="rules[checkType(item.interval_type)]" />
                                    </v-col>
                                    <v-col sm="3" cols="6" :order-2="item.interval_type == 'before-hour-on-check-in-day'" :order-3="item.interval_type == 'days-until-check-in'" class="py-0">
                                        <v-select :items="interval_types" v-model="item.interval_type" :label="$t('cancellation_policy.rule.interval_value')" required />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col md="5" cols="11" class="py-0">
                                <v-row align="center">
                                    <v-col cols="6" class="py-0" v-if="$vuetify.breakpoint.smAndUp">
                                        <div v-if="item.interval_type == 'days-until-check-in'">
                                            {{ $t('cancellation_policy.rule.text.days_part_two') }}
                                        </div>
                                        <div v-if="item.interval_type == 'before-hour-on-check-in-day'">
                                            {{ $t('cancellation_policy.rule.text.hour_part_two') }}
                                        </div>
                                    </v-col>
                                    <v-col sm="3" cols="5" class="py-0">
                                        <v-text-field :label="$t('cancellation_policy.rule.penalty_value')" v-model="item.penalty_value" required :rules="rules.value" />
                                    </v-col>
                                    <v-col sm="3" cols="7" class="py-0">
                                        <v-select :items="value_types" v-model="item.penalty_type" class="text-truncate no-wrap-select" :label="$t('cancellation_policy.rule.penalty_type')" required :rules="rules.penalty"></v-select>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col md='1' cols="1" class="py-0">
                                <v-icon v-if="policy.rules.length != 1" size="24" color="red" @click="removeRule(index)">delete</v-icon>
                            </v-col>
                        </v-row>
                        <div class="d-flex justify-end" v-if="policy.rules.length < 5">
                            <v-btn small color="primary" @click="addRule()">
                                {{ $t('cancellation_policy.button.add_new_rule') }}
                            </v-btn>
                        </div>
                    </div>
                </v-card-text>
            </v-form>
        </v-card>
    </v-container>

    <v-snackbar v-model="error_data" color="error" bottom left>
        <div>
            <div>Numele este obligatoriu</div>
        </div>
    </v-snackbar>

    <!--delete dialog-->
    <im-dialog-confirmation :dialog="delete_dialog" @cancel="delete_dialog=false" @delete="destroy()">
        <span slot="text-confirmation">{{ $t('cancellation_policy.message_delete_confimation') }}</span>
    </im-dialog-confirmation>
    <!--./delete dialog -->
    <!-- footer -->
    <im-footer :create='!!(policy.id)' :update="modified&&(original_full_refundable==full_refundable)" :loading="loading_save" @save="saveItem()" @refresh="refresh()" @delete="deleteItem()" />
    <!-- ./ footer -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from '../../components/utils/PropDefaults.js';
import IMHeader from '../../components/utils/IMHeader.vue';
import IMFooter from '../../components/utils/IMFooter.vue';
import ImDialogConfirmation from '../../components/utils/ImDialogConfirmation.vue';

export default {
    props: ['hotel'],
    components: {
        "im-header": IMHeader,
        "im-footer": IMFooter,
        "im-dialog-confirmation": ImDialogConfirmation
    },
    data() {
        return {
            error_data: false,
            full_refundable: true,
            original_full_refundable: true,
            type_policy: 0,
            valid: true,
            name: defaults.policy_name,
            delete_dialog: false,
            loading: false,
            loading_save: false,
            loading_delete: false,
            policy: this.$clone(defaults.cancellation_policy_item),
            original_item: this.$clone(defaults.cancellation_policy_item),

        };
    },

    watch: {
        '$route.params': {
            async handler() {
                await this.hotel
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug)
                    if(this.hotel.id) {
                        this.value_types[0].text = this.hotel.currency
                    }
                    if(this.$route.params.id) {
                        this.getItem();
                    }
                } else {
                    if(this.hotel.id) {
                        this.value_types[0].text = this.hotel.currency
                    }
                    if(this.$route.params.id) {
                        this.getItem();
                    }
                }
            },
            deep: true,
            immediate: true
        },

        'hotel.id': function (new_hotel, old_hotel) {
            if(new_hotel !== JSON.parse(localStorage.getItem('hotel'))
                .id) {
                this.value_types[0].text = this.hotel.currency;
                this.$router.push({
                    path: '/' + this.hotel.slug + '/cancellation-policies'
                });
            }
        },

    },
    computed: {

        modified: function () {
            if(this.$route.params.id) {
                let original = this.$clone(this.original_item);
                let item = this.$clone(this.policy);
                delete original.text;
                delete item.text;
                return (JSON.stringify({ ...item
                }) == JSON.stringify({ ...original
                }))
            } else {
                return false
            }
        },

        description: {
            get: function () {
                let data_policy = this.$clone(this.policy);
                let text = '';

                data_policy.rules.forEach(function (rule, index) {
                    let value_type = "";
                    switch (rule.penalty_type) {
                    case "fixed":
                        value_type = this.hotel.currency;
                        break;
                    case "percent":
                        value_type = this.$t('cancellation_policy.description_penalty_type_percent');
                        break;
                    case "first-night-percent":
                        value_type = this.$t('cancellation_policy.description_penalty_type_first_night');
                        break;
                    }
                    if(rule.interval_type == 'days-until-check-in' && (rule.interval_value !== null && rule.penalty_value !== null && rule.penalty_value && rule.penalty_type !== null)) {
                        text = text + this.$t('cancellation_policy.description_days_text', [rule.interval_value, rule.penalty_value, value_type]);
                    }
                    if(rule.interval_type == 'before-hour-on-check-in-day' && (rule.interval_value !== null && rule.penalty_value !== null && rule.penalty_value && rule.penalty_type !== null)) {
                        text = text + this.$t('cancellation_policy.description_hour_text', [rule.interval_value, rule.penalty_value, value_type]);
                    }
                }.bind(this))
                return text;
            },
            set: function (newValue) {}
        },

        rules() {
            return {
                name: [v => !!v || this.$t('cancellation_policy.form_rules.name')],
                value: [v => !!v || this.$t('cancellation_policy.form_rules.value')],
                penalty: [v => !!v || this.$t('cancellation_policy.form_rules.penalty')],
                days: [
                    v => !!v || this.$t('cancellation_policy.form_rules.days_required'),
                    v => /^[0-9]{1,3}$/.test(v) || this.$t('cancellation_policy.form_rules.days_format')
                ],
                time: [
                    v => !!v || this.$t('hotel.policy.form_rules.time_required'),
                    v => /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || this.$t('hotel.policy.form_rules.time_format')
                ],
            }
        },

        interval_types() {
            return [{
                    text: this.$t('cancellation_policy.rule.days'),
                    value: 'days-until-check-in'
                }, {
                    text: this.$t('cancellation_policy.rule.hour'),
                    value: 'before-hour-on-check-in-day'
                }
            ]
        },

        value_types() {
            return [{
                    text: this.hotel.currency,
                    value: 'fixed'
                }, {
                    text: this.$t('cancellation_policy.rule.percent'),
                    value: 'percent'
                }, {
                    text: this.$t('cancellation_policy.rule.first_night_percent'),
                    value: 'first-night-percent'
                }
            ]
        }
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        this.$emit('changeHotel', [response.data.hotel_id, false]);
                    } else {
                        this.error("Oops, something went wrong!");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
        },

        getItem() {
            if(!this.hotel.id) {
                return;
            }
            this.loading = true;
            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel.id,
                }
            };
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/cancellation-policies/' + this.$route.params.id;

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(this.hotel.id !== response.data.hotel_id) {
                        this.error(this.$t('cancellation_policy.message_no_acces'));
                        this.$router.push({
                            path: '/dashboard'
                        });
                        return
                    }

                    this.policy = response.data;
                    this.name = this.policy.name;
                    if(this.policy.rules === null) {
                        this.policy.rules = [];
                    }
                    if(this.policy.refundable && this.policy.rules.length > 0) {
                        this.full_refundable = false;
                        this.original_full_refundable = false;
                    }
                    this.original_item = this.$clone(this.policy);
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        saveItem() {
            if(!this.policy.name) {
                this.error_data = true;
            }

            if(!this.$refs.form.value) {
                this.$refs.form.validate();
                return
            }

            this.loading_save = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/cancellation-policies/';

            let data_policy = this.policy;
            if(data_policy.refundable) {
                // refundable
                if(this.full_refundable) {
                    // full refundable
                    data_policy.rules = [];
                    data_policy.text = {
                        ro: "Complet rambursabila",
                        en: "Full refundable"
                    };
                } else {
                    // partial refundable
                    data_policy.text = {
                        ro: "",
                        en: ""
                    };

                    data_policy.rules.forEach(function (rule, index) {
                        let value_type = {
                            ro: '',
                            en: ''
                        };
                        switch (rule.penalty_type) {
                        case "fixed":
                            value_type.ro = this.hotel.currency;
                            value_type.en = this.hotel.currency;
                            break;
                        case "percent":
                            value_type.ro = this.$i18n.messages.ro.cancellation_policy.description_penalty_type_percent;
                            value_type.en = this.$i18n.messages.en.cancellation_policy.description_penalty_type_percent;
                            break;
                        case "first-night-percent":
                            value_type.ro = this.$i18n.messages.ro.cancellation_policy.description_penalty_type_first_night;
                            value_type.en = this.$i18n.messages.en.cancellation_policy.description_penalty_type_first_night;
                            break;
                        }
                        if(rule.interval_type == 'days-until-check-in') {
                            let ro = this.$i18n.messages.ro.cancellation_policy.description_days_text.replace('{0}', rule.interval_value)
                                .replace('{1}', rule.penalty_value)
                                .replace('{2}', value_type.ro);
                            let en = this.$i18n.messages.en.cancellation_policy.description_days_text.replace('{0}', rule.interval_value)
                                .replace('{1}', rule.penalty_value)
                                .replace('{2}', value_type.en);
                            data_policy.text.ro = data_policy.text.ro + ro;
                            data_policy.text.en = data_policy.text.en + en;
                        }
                        if(rule.interval_type == 'before-hour-on-check-in-day') {
                            let ro = this.$i18n.messages.ro.cancellation_policy.description_hour_text.replace('{0}', rule.interval_value)
                                .replace('{1}', rule.penalty_value)
                                .replace('{2}', value_type.ro);
                            let en = this.$i18n.messages.en.cancellation_policy.description_hour_text.replace('{0}', rule.interval_value)
                                .replace('{1}', rule.penalty_value)
                                .replace('{2}', value_type.en);
                            data_policy.text.ro = data_policy.text.ro + ro;
                            data_policy.text.en = data_policy.text.en + en;
                        }
                    }.bind(this))
                }
            } else {
                // non-refundable
                data_policy.rules = []
            }

            if(this.$route.params.id !== undefined) {
                this.$axios.put(endpoint + data_policy.id, data_policy)
                    .then(response => {
                        this.success(this.$t('cancellation_policy.message_edited'));
                        this.$router.push({
                            path: '/' + this.hotel.slug + '/cancellation-policies'
                        });
                    })
                    .catch(error => {
                        this.error("Oops, something went wrong!");
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            } else {
                data_policy.hotel_id = this.hotel.id;
                this.$axios.post(endpoint, data_policy)
                    .then(response => {
                        this.success(this.$t('cancellation_policy.message_added'));
                        this.$router.push({
                            path: '/' + this.hotel.slug + '/cancellation-policies'
                        });
                    })
                    .catch(error => {
                        this.error("Oops, something went wrong!");
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            }
        },

        deleteItem() {
            this.delete_dialog = true;
        },

        destroy() {
            this.loading_delete = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/cancellation-policies/";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel.id
                }
            };

            // call delete endpoint
            this.$axios.delete(endpoint + this.$route.params.id, params)
                .then(response => {
                    this.success(this.$t('cancellation_policy.message_deleted'));
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.loading_delete = false;
                    this.delete_dialog = false;
                    this.$router.push({
                        path: '/' + this.hotel.slug + '/cancellation-policies'
                    });
                });
        },

        addFirstRule() {
            this.policy.rules.push({
                interval_value: 30,
                interval_type: 'days-until-check-in',
                penalty_value: 100,
                penalty_type: 'percent',
            });
        },

        addRule() {
            this.policy.rules.push({
                interval_value: null,
                interval_type: 'days-until-check-in',
                penalty_value: null,
                penalty_type: 'percent',
            });
        },

        removeRule(key) {
            if(this.policy.rules.length > 0) {
                this.policy.rules.splice(key, 1);
            }
        },

        checkType(value) {
            if(value == 'days-until-check-in') {
                return 'days'
            } else {
                return 'time'
            }
        },

        back() {
            this.$router.push({
                path: '/' + this.hotel.slug + '/cancellation-policies'
            });
        },

        refresh() {
            this.$refs.form.reset();
            this.full_refundable = true;
            this.original_full_refundable = true;
            if(!this.$route.params.id) {
                this.policy = this.$clone(defaults.cancellation_policy_item);
            } else {
                this.getItem();
            }
        },
    }
};
</script>
<style lang="stylus">
.v-select
    &.no-wrap-select
        .v-select__selections
            flex-wrap: nowrap
</style>
